import { Injectable } from '@angular/core';
import { Language } from 'src/app/interfaces/language.interface';
import { LanguageService } from 'src/app/service/language/language.service';

@Injectable({
    providedIn: 'root'
})
export class InitLanguagesService {

    constructor(private languageService: LanguageService){
    }

    async loadLanguages(){
        await this.languageService.getLanguageService().then((response: { data: { data: Language[]; }; }) => {
            localStorage.setItem('languages_data', JSON.stringify(response.data.data));
        });
    }
}